import React, { useState } from "react";
import { IPriceSize } from "../../shared/interfaces/size";
import { IStoragePrice } from "../../shared/interfaces/storage";
import "./PriceStep.css";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import deAt from "date-fns/locale/de-AT";
import { tS } from "../../services/translation.service";
registerLocale("de-AT", deAt);

interface IProps {
  selectedSize: IPriceSize | undefined;
  startDate: Date;
  setStoragePrice: (storagePrice: IStoragePrice) => void;
  setStartDate: (newStartDate: Date) => void;
  onNextStep: () => void;
  onSizesStepBack: () => void;
  isBlindFlow: boolean;
  isGerman: boolean;
  selectedLanguage: number;
}

export const PriceStep = (props: IProps) => {
  const {
    selectedSize,
    startDate,
    setStoragePrice,
    setStartDate,
    onNextStep,
    onSizesStepBack,
    isBlindFlow,
    isGerman,
    selectedLanguage
  } = props;

  const months = selectedLanguage == 0 ? 
  ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"] : ( selectedLanguage == 2 ?
  ["Január", "Február", "Marec", "Apríl", "Máj", "Jún", "Júl", "August", "September", "Október", "November", "December"]:
  ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  );

  const [selectedHours, setSelectedHours] = useState(-1);
  const [selectedPrice, setSelectedPrice] = useState(-1);
  const [isDateOpen, setIsDateOpen] = useState(false);

  const [checked, setChecked] = React.useState(false);

  const isPriceSelected = selectedHours !== -1 && selectedPrice !== -1;

  const onSelectPriceHandler = (hours: number, price?: number) => {
    setSelectedHours(hours);
    if (price) {
      setSelectedPrice(price);
    }
  };

  const clearSelection = () => {
    setSelectedHours(-1);
    setSelectedPrice(-1);
    onSizesStepBack();
  };

  const handleChange = () => {
    setChecked(!checked);
  };

  const handleStartDateChange = (date: Date | null) => {
    setStartDate(date || new Date());
  };

  const handleClick = (e: any) => {
    e.preventDefault();
    setIsDateOpen(!isDateOpen);
  };

  const confirmSelection = () => {
    const body: IStoragePrice = {
      selectedHours: selectedHours,
      calculatedPrice: selectedPrice,
      startDate: startDate,
    };
    setStoragePrice(body);
    if (checked || isBlindFlow) {
      onNextStep();
    }
  };

  return !isPriceSelected ? (
    <div className="container">
      <p>
        {tS.gT(tS.P.CompartmentSize, selectedLanguage)} {selectedSize?.sizeName}
        <br />
        <b>
          {selectedSize?.height}cm x {selectedSize?.width}cm x {selectedSize?.depth}cm
        </b>
      </p>
      <button
        style={{ marginBottom: 10, marginTop: 10 }}
        onClick={() => onSelectPriceHandler(3, selectedSize?.threeHourPrice)}
      >
        3 {tS.gT(tS.P.Hours, selectedLanguage)} €{selectedSize?.threeHourPrice}
      </button>
      <button
        onClick={() => onSelectPriceHandler(24, selectedSize?.twoFourHourPrice)}
      >
        24 {tS.gT(tS.P.Hours2, selectedLanguage)} €{selectedSize?.twoFourHourPrice}
      </button>
      
      <div style={{ display: "flex", flexDirection: "column" }}>
        <p>
          {tS.gT(tS.P.StartTime, selectedLanguage)} {startDate.toLocaleDateString().replaceAll("/", ".")}{" "}
          {startDate.toTimeString().substring(0, 5)}
        </p>
        {!isBlindFlow &&
        <button
          style={{ padding: "0.2rem", width: "70%", alignSelf: "center" }}
          className="example-custom-input"
          onClick={handleClick}
        >
          {tS.gT(tS.P.ChangeStartTime, selectedLanguage)}
        </button> }
      </div> 

      <div style={{ marginTop: 10 }}>
        {isDateOpen && (
          <DatePicker
            timeCaption={tS.gT(tS.P.CalenderTime, selectedLanguage)}
            renderCustomHeader={({
              date,
              decreaseMonth,
              increaseMonth,
              prevMonthButtonDisabled,
              nextMonthButtonDisabled,
            }) => (
              <div
                style={{
                  margin: 5,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <button
                  style={{ padding: 0, width: 40, height: 40 }}
                  onClick={decreaseMonth}
                  disabled={prevMonthButtonDisabled}
                >
                  {"<"}
                </button>
                <p>
                  {months[date.getMonth()]} {date.getFullYear()}
                </p>

                <button
                  style={{ padding: 0, width: 40, height: 40 }}
                  onClick={increaseMonth}
                  disabled={nextMonthButtonDisabled}
                >
                  {">"}
                </button>
              </div>
            )}
            locale={"de-AT"}
            timeFormat={"HH:mm"}
            showTimeSelect
            selected={startDate}
            onChange={handleStartDateChange}
            inline
          />
        )}
      </div>
    </div>
  ) : (
    <div className="container">
      <p>
        {tS.gT(tS.P.DoYouWantToBook, selectedLanguage)} {selectedSize?.sizeName}
        <br />
        <b>
          {selectedSize?.height}cm x {selectedSize?.width}cm x {selectedSize?.depth}cm
        </b>{" "}
        {tS.gT(tS.P.For, selectedLanguage)} {selectedHours} {selectedHours === 3 ? tS.gT(tS.P.HoursAtThePrice, selectedLanguage) : tS.gT(tS.P.HoursAtThePrice2, selectedLanguage)} {selectedPrice} €{tS.gT(tS.P.Book, selectedLanguage)}
      </p>
      <div>
        <p style={{ display: "flex", alignItems: "center" }}>
          <a href="../agb" target="_blank">
            {!isBlindFlow ? tS.gT(tS.P.GTCRead, selectedLanguage) : 
            tS.gT(tS.P.GTCOpen, selectedLanguage)}
          </a>
          {!isBlindFlow &&
          <input type="checkbox" checked={checked} onChange={handleChange} /> }
        </p>
      </div>
      {!checked && <p>{tS.gT(tS.P.PleaseAcceptGTC, selectedLanguage)}</p>}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          padding: 10,
        }}
      >
        <button onClick={confirmSelection} style={{ marginRight: 10 }}>
          {(!isBlindFlow ? tS.gT(tS.P.Yes, selectedLanguage) : tS.gT(tS.P.YesIAccept, selectedLanguage))}
        </button>
        <button onClick={clearSelection}>{(!isBlindFlow ? tS.gT(tS.P.No, selectedLanguage) : tS.gT(tS.P.CancelBooking, selectedLanguage))}</button>
      </div>
    </div>
  );
};
